import * as moment from 'moment';
import { PreJaabstracts } from './juvenile-case-sections/pre-jaabstracts';
import { Transcript } from './juvenile-case-sections/transcript';
import { Abstract } from './juvenile-case-sections/abstract';
import { Attorney } from './juvenile-case-sections/attorney';
import { Order } from './juvenile-case-sections/order';
import { ServiceOfDocuments } from './juvenile-case-sections/serviceOfDocuments';
/* import { CaseEventHistory } from './juvenile-case-sections/caseEventHistory'; */
import { ConsolidatedCase } from './juvenile-case-sections/consolidatedCase';
import { TransferAndAppeals } from './juvenile-case-sections/transferAndAppeals';
/* import { TransferAppealsComponent } from './../case-view/juvenile/transfer-appeals/transfer-appeals.component';
import { TransferedFromCase } from './juvenile-case-sections/transferedFromCase';
import { Microfilm } from './juvenile-case-sections/microfilm'; */
import { Party } from './juvenile-case-sections/party';
import { Juvenile } from './juvenile-case-sections/juvenile';
import { Events } from './juvenile-case-sections/events'
import { Allegations } from './juvenile-case-sections/allegations'
import { Issue } from './juvenile-case-sections/issue';
import { SafeJSON } from './../shared/safe-json';
import { FileNumberUtil } from './../shared/file-number-util';
import { CaseIdentifier } from './../shared/case-identifier';
import { Pleading } from './juvenile-case-sections/pleading';
import { DatePipe } from '@angular/common';

const enum objectType {
    Issue,
    Party,
    Pleading,
    Microfilm,
    TransferedFromCase,
    TransferAndAppeals,
    ConsolidatedCase,
    CaseEventHistory,
    ServiceOfDocuments,
    Order,
    Attorney,
    Abstract,
    PreJAAbstract,
    Transcript,
    Juvenile,
    Events,
    Allegations
};

export class JuvenileCase {
    json: any;
    private juvenileNameFromSearch: string;
    private county = '';
    caseIdentifier: CaseIdentifier;
    private partyMap: Map<string, Party>;
    private pleadingMap: Map<string, Pleading>;
    private issueMap: Map<string, Issue>;
    /* private microfilmMap: Map<string, Microfilm>;
    private transferedFromCaseMap: Map<string, TransferedFromCase>; */
    private appealedIssueMap: Map<string, TransferAndAppeals>;
    private consolidatedCaseMap: Map<string, ConsolidatedCase>;
    // private caseEventHistoryMap: Map<string, CaseEventHistory>;
    private serviceOfDocumentsMap: Map<string, ServiceOfDocuments>;
    private orderMap: Map<string, Order>;
    private attorneyMap: Map<string, Attorney>;
    private abstractMap: Map<string, Abstract>;
    private preJAAbstractMap: Map<string, PreJaabstracts>;
    private transcriptMap: Map<string, Transcript>;
    private juvenileMap: Map<string, Juvenile>;
    private eventsMap: Map<string, Events>;
    private allegationsMap: Map<string, Allegations>;
    searchRecordLastUpdateDate: string = new Date().toJSON();

    pleadingShowFlags: boolean[];
    pleadingHideNotifyFlags: boolean[];

    /**
    * normalize a case number without the century, if there is, strip them out;
    * and stripping off the space e.g 2016JB 000001  to 16JB000001
    * @param caseNumber string
    */
   static normalizeCaseNumberForJuvenile(caseNumber: string): string {
    if (!caseNumber || caseNumber.trim() === '') {
        return '';
    }

    // removed the white spaces
    caseNumber = caseNumber.replace(/\s/g, '');
    caseNumber = caseNumber.substr(2, caseNumber.length);
    return caseNumber;
}

    constructor(json: any) {
        this.caseIdentifier =
            new CaseIdentifier('JUVENILE',
                json.countyName,
                json.caseNumber);
        this.json = json;
        // this.county = county;
        this.juvenileMap = this.buildMap<Juvenile>(SafeJSON.get('partyList', json), objectType.Juvenile);
        this.eventsMap = this.buildMap<Events>(SafeJSON.get('eventList', json), objectType.Events);
        this.allegationsMap = this.buildMap<Allegations>(SafeJSON.get('issueList', json), objectType.Allegations);
    }

    private buildMap<T>(obj, type: objectType): Map<string, T> {
        let map = new Map();
        Object.keys(obj).forEach(key => {
            let value;
            switch (type) {
                case objectType.Juvenile:
                    value = new Juvenile(key, obj[key], this.getNCJoinNumber());
                    break;
                case objectType.Events:
                    value = new Events(obj[key], key);
                    break;
                case objectType.Allegations:
                    value = new Allegations(obj[key], key);
                    break;
                case objectType.Issue:
                    value = new Issue(obj[key], key);
                    break;
                case objectType.Party:
                    // Since new json structure gives us two lists, one for each party type (D, P, etc)
                    // and a list of parties, in order, we need to combine the two lists back into
                    // one list for each type.  For exampl, enstead of having D: {1,2,3,...} and P: (1,2,...}
                    // we now have {D1, D2, D3, ...} and {P1, P2, P3,...}.
                    const partiesByRole = obj[key];
                    Object.keys(partiesByRole).forEach(partyNumber => {
                        // Get each party from the list for that party type (D, P, etc)
                        const partyKey = key + partyNumber;
                        let partyValue = new Party(partiesByRole[partyNumber], partyKey);
                        map.set(partyKey, partyValue);
                    });
                    return map; // we need to return here since we already added the mappings
                case objectType.Pleading:
                    value = new Pleading(obj[key], key);
                    break;
                /* case objectType.Microfilm:
                    value = new Microfilm(obj[key], key);
                    break;
                case objectType.TransferedFromCase:
                    value = new TransferedFromCase(obj[key], key);
                    break; */
                case objectType.TransferAndAppeals:
                    value = new TransferAndAppeals(obj[key], key);
                    break;
                case objectType.ConsolidatedCase:
                    value = new ConsolidatedCase(obj[key], key);
                    break;
                /*  case objectType.CaseEventHistory:
                     value = new CaseEventHistory(obj[key], key);
                     break; */
                case objectType.ServiceOfDocuments:
                    value = new ServiceOfDocuments(obj[key], key);
                    break;
                case objectType.Order:
                    value = new Order(obj[key], key);
                    break;
                case objectType.Attorney:
                    value = new Attorney(obj[key], key);
                    break;
                case objectType.Abstract:
                    value = new Abstract(obj[key], key);
                    break;
                case objectType.PreJAAbstract:
                    value = new PreJaabstracts(obj[key], key);
                    break;
                case objectType.Transcript:
                    value = new Transcript(obj[key], key);
                    break;
                default:
                    break;
            }
            map.set(key, value);
        });
        return map;
    }

    // Juvenile changes
    getJuvenileName(): string {
        let juvenileName: any = SafeJSON.get('juvenileName', this.json);
        return juvenileName;
    }

    getNCJoinNumber(): string {
        let ncJoinNumber: string = SafeJSON.getWithDefault('ncJoinId', this.json);
        if (ncJoinNumber === '-') {
            ncJoinNumber = 'No NCJoin Number Recorded';
        }
        return ncJoinNumber;
    }

    getDateOfBirth(): string {
        return SafeJSON.get('dateOfBirth', this.json);
    }

    getCaseCounty(): string {
        // return SafeJSON.get('countyName', this.json);
        // alert('County: ' + this.county);
        return this.caseIdentifier.county;
    }

    getCaseNumber(): string {
        // return SafeJSON.get('caseNumber', this.json);
        return this.caseIdentifier.caseNumber;
    }

    getFormattedCaseNumber(): string {
        let caseNumber: string = SafeJSON.get('caseNumber', this.json);
        return JuvenileCase.normalizeCaseNumberForJuvenile(caseNumber);
    }

    getCaseNotes(): string {
        let fileStatus: any = SafeJSON.get('notes', this.json);
        return fileStatus;
    }

    // getCaseStatus(): string {
    //        let caseStatus: any = SafeJSON.get('caseStatus', this.json);
    // 	   return caseStatus;
    // }

    getFileStatus(): string {
        let fileStatus: any = SafeJSON.get('caseStatus', this.json);
        return fileStatus;
    }

    getInterpretedNeeded(): string {
        return SafeJSON.get('languageDesc', this.json);
    }

    getInterpretedUsed(): string {
        return SafeJSON.get('interpreterUsedFlag', this.json);
    }

    getCourtRoom(): string {
        return SafeJSON.get('courtroom', this.json);
    }

    getCourtRoomCode(): string {
        return SafeJSON.get('courtroomCode', this.json);
    }


    getFileDestroyedPerRecordRetentionSchedule(): string {
        let flag: string = SafeJSON.get('physicalFileDestroyedFlag', this.json);

        if (flag === 'Y') {
            return 'YES';
        } else {
            return 'NO';
        }
    }

    getGuardianAdLitemInvolved(): string {
        let flag: string = SafeJSON.get('galFlag', this.json);

        if (flag === 'Y') {
            return 'YES';
        } else {
            return 'NO';
        }
    }

    getFamilyCourtInvolved(): string {
        let flag: string = SafeJSON.get('familyCourtFlag', this.json);

        if (flag === 'Y') {
            return 'YES';
        } else {
            return 'NO';
        }
    }

    getJudgeName(): string {
        return SafeJSON.get('judgeName', this.json);
    }

    getCaseStatusDescription(): string {
        let caseStatus: string = SafeJSON.get('caseStatus', this.json);

        if (caseStatus === 'OP') {
            return 'OPEN';
        }

        if (caseStatus === 'CL') {
            return 'CLOSED';
        }
    }
    // Juvenile changes end
    getpartyMap(): Map<string, Party> {
        return this.partyMap;
    }
    getCaseIdentifier(): CaseIdentifier {
        return this.caseIdentifier;
    }



    getPartyListByIssueKey(issueKey: string): Party[] {
        const issue = this.issueMap.get(issueKey);
        const partyKeys: string[] = issue.getIssuePartyCodes();

        const result = [];
        // First get the By parties
        for (let partyKey of partyKeys) {

            // we may get a party key that doesn't exist in the caseParties list
            if (!this.partyMap.has(partyKey)) {
                continue;
            }

            let party = this.partyMap.get(partyKey);
            party.setPartyKey(partyKey);   // change key from '1' to 'D1' for example

            if (issue.getIssueOrderPartyRole(party) === 'BY') {
                result.push(party);
            }
        }

        // Then add the Against parties
        const resultAgainst = [];
        for (let partyKey of partyKeys) {

            // we may get a party key that doesn't exist in the caseParties list
            if (!this.partyMap.has(partyKey)) {
                continue;
            }

            let party = this.partyMap.get(partyKey);
            party.setPartyKey(partyKey);   // change key from '1' to 'D1' for example

            if (issue.getIssueOrderPartyRole(party) === 'AGAINST') {
                resultAgainst.push(party);
            }
        }
        // lastly combine the grouped and sorted list and return it
        return result.concat(resultAgainst);
    }
    getIssueClockedInDate(juvenileCase: JuvenileCase, pleadingKey: string): string {
        const pleading: Pleading = juvenileCase.getPleadingByKey(pleadingKey);
        return pleading.getClockDate();
    }
    getIssueType(juvenileCase: JuvenileCase, issue: Issue): string {
        const issueType = issue.getType();
        return issueType;
    }
    getPleadingTypeDescription(juvenileCase: JuvenileCase, pleadingKey: string): string {
        const pleading: Pleading = juvenileCase.getPleadingByKey(pleadingKey);
        const description = pleading.getPleadingTypeDescription();
        return description;
    }
    getPartyByKey(partyKey: string): Party {
        return this.partyMap.get(partyKey);
    }
    getAbstractByKey(abstractRefKey: string): Abstract {
        return this.abstractMap.get(abstractRefKey);
    }
    getAbstractList(code: string): Abstract[] {
        return Array.from(this.abstractMap.values())
            .filter(abstract => abstract.getAbstractCode() === code);
    }
    getPreJAAbstractList(): PreJaabstracts[] {
        return Array.from(this.preJAAbstractMap.values());
    }
    getPartyListByRoleCode(roleCode: string): Party[] {
        return Array.from(this.partyMap.values())
            .filter(party => party.getPartyRoleCode() === roleCode);
    }
    getSpecialAbstractList(): Abstract[] {
        return Array.from(this.abstractMap.values())
            .filter(abstract => abstract.getAbstractCode() === 'Q');
    }

    getJuvenile(): Juvenile {
        let juvenile: Juvenile = Array.from(this.juvenileMap.values())
            .filter(juvenile => juvenile.getPartyType() === 'JUVENILE')
            .shift();
        this.juvenileNameFromSearch = juvenile.getJuvenileName();
        return juvenile;
    }


    getPartyList(): any[] {
        return Array.from(this.juvenileMap.values())
            .filter(juvenile => juvenile.getPartyType() !== 'JUVENILE');
    }

    getEventList(): any[] {
        this.pleadingShowFlags = new Array(this.eventsMap.size).fill(false, 0, (this.eventsMap.size));
        this.pleadingHideNotifyFlags = new Array(this.eventsMap.size).fill(false, 0, (this.eventsMap.size));
        let events: any[] = Array.from(this.eventsMap.values());

        events.sort(function (event1, event2) {
            let time1 = '00:00 AM';
            let time2 = '00:00 AM';

            if (event1.getEventTime() !== undefined) {
                time1 = event1.getEventTime() ? event1.getEventTime() : time1;
            }

            if (event2.getEventTime() !== undefined) {
                time2 = event2.getEventTime() ? event2.getEventTime() : time2;
            }

            const date1 = new Date(moment(event1.getEventDate(), 'YYYY-MM-DD').format('MM/DD/YYYY') + ' ' + time1);
            const date2 = new Date(moment(event2.getEventDate(), 'YYYY-MM-DD').format('MM/DD/YYYY') + ' ' + time2);

            // Sort by Date and Time
            return (date2.getTime() - date1.getTime());
        });

        return events;
    }

    getAllegationsList(): any[] {
        return Array.from(this.allegationsMap.values());
    }

    getIssueListByAbstractKey(abstractRefKey: string): Issue[] {
        /*
        FBR430	Display a listing of the issues covered by this Judgment
        sorted on the Issue Clocked In Date in chronological order first and
        then by the Pleading Type and the Issue Type in alphabetical order.
        */
        let juvenileCase = this;   // Note: you can't simply pass 'this' in the sort function
        let list: Issue[] = Array.from(this.issueMap.values())
            .filter(issue => issue.getAbstractRefKey() === abstractRefKey);

        list
            .sort(function (p1, p2) {
                return p1.getType().localeCompare(p2.getType());
            })
            .sort(function (p1, p2) {
                return p1.getPleadingDescription(juvenileCase).localeCompare(p2.getPleadingDescription(juvenileCase));
            })
            .sort(function (p1, p2) {
                return p1.getPleadingClockedInDate(juvenileCase).localeCompare(p2.getPleadingClockedInDate(juvenileCase));
            })
            ;
        return list;
    }
    getPleadingList(): Pleading[] {
        // Fixed sort to nesting verse chaining.
        const pleadingList = Array.from(this.pleadingMap.values());

        // sort pleadings list by clock date, then by pleading type (name)
        pleadingList.sort(function (p1, p2) {
            let result = p1.getClockDate().localeCompare(p2.getClockDate());
            if (result !== 0) {
                return result;
            }
            return p1.getType().localeCompare(p2.getType());
        });
        return pleadingList;
    }
    getPleadingByKey(key: string): Pleading {
        return this.pleadingMap.get(key);
    }
    getIssueListByKey(key: string): Issue {
        return this.issueMap.get(key);
    }
    getIssueListByPleadingKey(pleadingKey: string): Issue[] {
        let issueList: Issue[] = Array.from(this.issueMap.values())
            .filter(issue => issue.getPleadingKey() === pleadingKey);

        issueList.sort(function (p1, p2) {
            return p1.getType().localeCompare(p2.getType());
        });
        return issueList;
    }
    getPartyNameByPartyNumber(partyNumber: string): string {
        for (let party of Array.from(this.partyMap.values())) {
            let partyNum = Number(partyNumber);
            if (party.getPartyNumber() === partyNum) {
                return party.getName();
            }
        }
        return '-';
    }
    getPartyNameByPartyRef(partyRef: string): string {
        let party = this.partyMap.get(partyRef);
        if (party === undefined) {
            return '-';
        }
        return party.getName();
    }
    getPartyDescriptionByPartyRef(partyRef: string): string {
        let party = this.partyMap.get(partyRef);
        if (party === undefined) {
            return '-';
        }
        return party.getPartyRole();
    }
    getPartyNumberByPartyRef(partyRef: string): number {
        let party = this.partyMap.get(partyRef);
        if (party === undefined) {
            return 0;
        }
        return party.getPartyNumber();
    }
    /* getMicroFilmList(): Microfilm[] {
        return Array.from(this.microfilmMap.values());
    } */
    getTranscriptList(): Transcript[] {
        /*  Note David Finley helped with this sort.  Its not chained, its nested which is what I want.
            Display a listing of all the transcripts of judgments for the case sorted
            by the Date and Time of Transcript in chronological order and then
                by the Abstract field
                    where the abstracts with a book and page number
                    will be listed first in ascending numerical order,
                    followed
                    by the abstracts with an alpha sequence number in alphabetical order and
                    then the abstracts with the numeric sequence numbers displayed in ascending numerical order.
        */
        let tlist: Transcript[] = Array.from(this.transcriptMap.values());
        const SPECIALBOOKPAGE8S = '888';
        const SPECIALBOOKPAGE9S = '999';

        return tlist.sort(function (p1, p2) {
            const result = p1.getDateTimeOmitSeconds().localeCompare(p2.getDateTimeOmitSeconds());
            if (result !== 0) {
                return result;
            }

            // Dates are the same so look at the abstract number or the book/page
            if (result === 0) {
                const p1DocketBookNum = SafeJSON.get('docketBookNum', p1.json);
                const p1DocketPageNum = SafeJSON.get('docketPageNum', p1.json);
                const p2DocketBookNum = SafeJSON.get('docketBookNum', p2.json);
                const p2DocketPageNum = SafeJSON.get('docketPageNum', p2.json);

                if (p1DocketBookNum !== '' && p2DocketBookNum !== ''
                    && p1DocketBookNum !== SPECIALBOOKPAGE8S && p1DocketBookNum !== SPECIALBOOKPAGE9S
                    && p2DocketBookNum !== SPECIALBOOKPAGE8S && p2DocketBookNum !== SPECIALBOOKPAGE9S) {

                    if (p1DocketBookNum !== p2DocketBookNum) {
                        return p1.getDocketBookNum().localeCompare(p2.getDocketBookNum());
                    }
                    return p1.getDocketPageNum().localeCompare(p2.getDocketPageNum());
                }
            }
            // No book/page to compare, so just use the abstract number
            const abstractCodeCompare = p1.json.abstractCode.localeCompare(p2.json.abstractCode);
            if (abstractCodeCompare !== 0) {
                return abstractCodeCompare;
            }
            return p1.json.abstractNumber.localeCompare(p2.json.abstractNumber);
        });
    }
    getAppealedIssueList(): TransferAndAppeals[] {
        if (Array.from(this.appealedIssueMap.values()).length === 0) {
            return new Array<TransferAndAppeals>();
        }

        let list: any[] = Array.from(this.appealedIssueMap.values());
        // sort pleadings list by clock date, then by pleading type (name)
        list.sort(function (p1, p2) {
            if (p1.json.appealDate === undefined || p2.json.appealDate === undefined) {
                return 0;
            }
            return p1.json.appealDate.localeCompare(p2.json.appealDate);
        });
        return list;
    }
    getAppealToCase(): any {
        let section = SafeJSON.getWithDefault('appealTo', this.json);
        return section;
    }
    getAppealFromCase(): any {
        let section = SafeJSON.getWithDefault('appealFrom', this.json);
        return section;
    }
    getAppealToCaseNumber(): any {
        let caseNumber = SafeJSON.getWithDefault('appealTo.caseNumber.formattedShortFileNumber', this.json);
        return this.getCourtTypeName(caseNumber) + ' ' + caseNumber;
    }
    getAppealFromCaseNumber(): any {
        let section = SafeJSON.getWithDefault('appealFrom.caseNumber.formattedShortFileNumber', this.json);
        return section;
    }
    getAppealToAppealDate(): any {
        return SafeJSON.get('appealTo.appealDate', this.json);
    }
    getAppealFromAppealDate(): any {
        return SafeJSON.get('appealFrom.appealDate', this.json);
    }
    getPerfectedIndication(appealSource: string): string {
        const fileCaseNumber: string = this.getCaseNumber();
        let caseType = FileNumberUtil.getCaseType(fileCaseNumber);
        // caseType = 'CVM'; // TODO remove
        if (caseType !== 'CVM') {
            return '';
        }
        let paidIndicator = this.getAppealFromPaidIndicator();
        if (appealSource === 'TO') {
            paidIndicator = this.getAppealToPaidIndicator();
        }
        if (paidIndicator === 'N') {
            return '(NOTICE OF APPEAL)';
        }
        return '';
    }
    getAppealFromPaidIndicator(): string {
        return SafeJSON.get('appealFrom.paidInd', this.json);
    }
    getAppealToPaidIndicator(): string {
        return SafeJSON.get('appealTo.paidInd', this.json);
    }
    getConsolidatedCaseList(): any[] {
        if (Array.from(this.consolidatedCaseMap.values()).length === 0) {
            return [];
        }
        // return a properly sorted list of consolidated cases

        // convert the map to an array so we can manipulate it easily
        let consolidatedCaseList: ConsolidatedCase[] = Array.from(this.consolidatedCaseMap.values());

        /* Sort:
             Consolidation Order Clock Date in chronological order,
             and then by
               Case County in alphabetical order,
                 and then by
                   Case Number in ascending order.

          Sort them in reverse (nested) order to build the array in the sort order we want!

          The nested sort comes in to play when the current sort callback function determines that
          the items are equal; then it moves down the chain to the next sort callback.
          For example, the dates are the same so look at the county names for those two items.
          Likewise, if the dates and county names are the same, look at the filecase numbers to
          determine the order.
        */
        consolidatedCaseList.sort(function (p1, p2) {
            return p1.getConsolidationCaseNumber().localeCompare(p2.getConsolidationCaseNumber());
        }).sort(function (p1, p2) {
            return p1.getConsolidationCaseCounty().localeCompare(p2.getConsolidationCaseCounty());
        }).sort(function (p1, p2) {
            return p1.getConsolidationOrderClockDate().localeCompare(p2.getConsolidationOrderClockDate());
        });


        let i = 0;
        let leadCase: ConsolidatedCase[];
        for (let consolidatedCase of consolidatedCaseList) {

            if (this.getConsolidatedCaseLeadIndicator(consolidatedCase) !== '') {
                // Now pull out the lead case we found and combine arrays with lead case on top
                leadCase = consolidatedCaseList.splice(i, 1);
                return leadCase.concat(consolidatedCaseList);
            }
            i++;
        }
        // we didn't find any lead cases so just return the sorted list
        return consolidatedCaseList;
    }
    /* getCaseEventHistoryList(): CaseEventHistory[] {
        return Array.from(this.caseEventHistoryMap.values());
    }; */
    getServiceOfDocumentsList(): ServiceOfDocuments[] {
        /*
            Display a listing of all the service records for the parties on the case,
            sorted by the Issued Date and Time in chronological order
            and then by Party To Be Served in alphabetical order.
        */
        let juvenileCase = this;   // Note: you can't simply pass 'this' in the sort function
        let serviceOfDocuments: ServiceOfDocuments[] = Array.from(this.serviceOfDocumentsMap.values());
        if (serviceOfDocuments.length === 0) {
            return [];
        }
        serviceOfDocuments.sort(function (p1, p2) {
            return p1.getPartyNameByPartyRef(juvenileCase).localeCompare(p2.getPartyNameByPartyRef(juvenileCase));
        }).sort(function (p1, p2) {
            return p1.getIssuedOnDate().localeCompare(p2.getIssuedOnDate());
        });
        return serviceOfDocuments;
    }
    getOrderList(): Order[] {
        return Array.from(this.orderMap.values());
    }
    getAttorneyList(): any[] {
        if (Array.from(this.attorneyMap.values()).length === 0) {
            return [];
        }
        const list: any[] = Array.from(this.attorneyMap.values());

        list.sort(function (p1, p2) {
            return p1.json.name.localeCompare(p2.json.name);
        });
        return list;
    }
    getCaseType(): string {
        return FileNumberUtil.getCaseType(this.getCaseNumber());
    }
    getCaseTypeCaptionDescription(): string {
        const description = SafeJSON.getWithDefault('caseTypeDescription', this.json);
        if (description !== '-') {
            return '(' + description + ')';
        }
        return '';
    }
    getCaseTypeDescription(): string {
        let caseType: string = this.getCaseType();
        return FileNumberUtil.getCaseTypeDescription(caseType);
    }
    getCourtTypeName(caseNumber): string {
        let caseType: string = FileNumberUtil.getCaseType(caseNumber);
        return FileNumberUtil.getLongCourtTypeDescription(caseType);
    }
    getTransferAndAppealsNotice(): string {
        const transferTo = this.getTransferedTo();
        const appealTo = this.getAppealToCase();
        const appealsList: any[] = this.getAppealedIssueList();
        if (transferTo !== '-' || appealTo !== '-' || appealsList.length > 0) {
            return '(See Transfers and Appeals)';
        }
        return '';
    }
    getFromAppealedCaseNumber(): string {
        // look for From case first
        let fileNumber: string = this.getInitiatedAppealFromCaseNumber();
        if (fileNumber !== '-') {
            let caseType: string = FileNumberUtil.getCaseType(fileNumber);
            return '(appealed from ' + FileNumberUtil.getLongCourtTypeDescription(caseType) + ' ' + fileNumber + ')';
        }
    }
    getToAppealedCaseNumber(): string {
        // look for To case
        let fileNumber = this.getAppealToFormattedShortFileNumber();
        if (fileNumber !== '') {
            let caseType: string = FileNumberUtil.getCaseType(fileNumber);
            return '(appealed to ' + FileNumberUtil.getLongCourtTypeDescription(caseType) + ' ' + fileNumber + ')';
        }
        return '';
    }
    /*getCaseStatus(): string {
        return SafeJSON.getWithDefault('caseStatus.code', this.json);
    }
    getCaseStatusDescription(): string {
        return SafeJSON.getWithDefault('caseStatus.description', this.json);
    } */
    getJudgmentDocketedAndIndexed(): string {
        return SafeJSON.getWithDefault('judgmentDocketedAndIndexed', this.json);
    }
    getInitiatingPleadingAndIssue(): string {
        return SafeJSON.getWithDefault('initiatingPleadingAndIssue', this.json);
    }
    /* getCaseNumber(): string {
         return SafeJSON.get('juvenileCase.caseNumber.fileNumber', this.json);
     }
     getCaseCounty(): string {
         let countyName = SafeJSON.get('juvenileCase.caseNumber.county', this.json);
         if (countyName === '') {
             return SafeJSON.get('juvenileCase.caseNumber.countyNumber', this.json);
         }
         return countyName;
     } */
    getCaseCaption(): string {
        return SafeJSON.get('caseCaption', this.json);
    }
    getPartyName(): string {
        return SafeJSON.getWithDefault('name', this.json);
    }

    // Case Information ///////////////////////////////////////////////////////
    getPresidingOfficialNumber(): string {
        return SafeJSON.getWithDefault('juvenileCase.presidingOfficialNumber', this.json);
    }
    getDomesticCaseType(): string {
        let caseType = this.getCaseType();
        if (caseType !== 'CVD') {
            return '-';
        }
        return SafeJSON.getWithDefault('juvenileCase.domesticType.description', this.json);
    }
    getDisposedOn(): string {
        let rawDate: string = SafeJSON.get('juvenileCase.dispositionClockDate', this.json);
        return rawDate;
    }
    getConsolidationOrderClockDate(consolidatedCase: any): string {
        return SafeJSON.get('dispositionClockDate', consolidatedCase.json);
    }
    getConsolidationCounty(consolidatedCase: any): string {
        return SafeJSON.getWithDefault('caseNumber.county', consolidatedCase.json);
    }
    getConsolidationCaseNumber(consolidatedCase: any): string {
        return SafeJSON.get('caseNumber.fileNumber', consolidatedCase.json);
    }
    getConsolidationCaseCaption(consolidatedCase: any): string {
        return SafeJSON.getWithDefault('caseCaption', consolidatedCase.json);
    }

    /*
    UX323-CL Display the lead case information first and display the remaining case
    numbers sorted by the Consolidation Order Clock Date in chronological order and
    then by the Case County in alphabetical order and the by the Case Number in
    ascending order.

    UX323 lead case explained - When there is a section for ‘consolidatedCaseList’ and
     section ‘leadConsolidatedCase’ does NOT exist, then the case number for the JSON is
    the lead case.  Examine each consolidated case for the json case number and mark it as Lead Case.

    When there is a section for ‘consolidatedCaseList’ and section ‘leadConsolidatedCase’
    DOES exist, then the caseNumber in leadConsolidatedCase section is the lead.
*/
    getConsolidatedCaseLeadIndicator(consolidatedCase: any): string {
        const leadCaseLabel = '(Lead Case)';

        // If this method is invoked, then the ‘consolidatedCaseList’ exists.
        let leadConsolidatedCase = SafeJSON.getWithDefault('leadConsolidatedCase', this.json);
        let consolidatedCaseFileNumber = this.getConsolidationCaseNumber(consolidatedCase);

        if (leadConsolidatedCase === '-') {
            // no leadConsoliatedCase section found.
            // match the case number in the list to the json case number
            let caseFileNumber = this.getCaseNumber();
            if (consolidatedCaseFileNumber === caseFileNumber) {
                return leadCaseLabel;
            }
        } else {
            let leadConsolidatedCaseFileNumber = SafeJSON.getWithDefault('caseNumber.fileNumber', leadConsolidatedCase);
            if (consolidatedCaseFileNumber === leadConsolidatedCaseFileNumber) {
                return leadCaseLabel;
            }
        }
        return '';
    }
    getPresidingOfficialName(): string {
        return SafeJSON.getWithDefault('juvenileCase.presidingOfficialName', this.json);
    }
    getJuryTrialWasRequested(): string {
        let field = this.caseEventCodeFound('JRDM');
        if (field === '-') {
            return 'NO';
        }
        return field;
    }
    getEligibleforMediatedSettlementConference(): string {
        let caseType = this.getCaseType();
        if (caseType === 'CVD' || caseType === 'CVS') {
            return this.caseEventCodeFound('ELME');  // these are the only valid case types where we show this field
        }
        return '-';
    }
    getEligibleForCustodyVisitationMediation(): string {
        let caseType = this.getCaseType();
        if (caseType === 'CVD' || caseType === 'CVS') {
            return this.caseEventCodeFound('ELCU');  // these are the only valid case types where we show this field
        }
        return '-';
    }
    getEligibleForArbitration(): string {
        let caseType = this.getCaseType();
        if (caseType === 'CVD' || caseType === 'CVS') {
            return this.caseEventCodeFound('ELAR');  // these are the only valid case types where we show this field
        }
        return '-';
    }
    getInterpreterNeeded(): string {
        return SafeJSON.getWithDefault('interpreterLanguage', this.json);
    }
    getInterpreterUsed(): string {
        if (this.getInterpreterNeeded() === '-') {
            return '-';
        }
        let used = SafeJSON.getWithDefault('interpreterUsed', this.json);
        if (used === '1') {
            return 'YES';
        }
        return 'NO';
    }
    getCourtSessionDate(): string {
        return SafeJSON.get('caseCalendar.beginDate', this.json);
    }
    getCourtSessionTime(): string {
        return SafeJSON.getWithDefault('caseCalendar.trialTime', this.json);
    }
    getCourtSessionRoom(): string {
        return SafeJSON.getWithDefault('caseCalendar.caseCalendarLocation.description', this.json);
    }
    getCourtSessionNotes(): string {
        return SafeJSON.getWithDefault('caseCalendar.note', this.json);
    }
    getDigitalScanMicrofilmLocationNumbers(key: string): string {
        let year = SafeJSON.get('json.filmYear', key);
        let stringYear: string = year.toString();
        if (stringYear !== undefined && stringYear !== '') {
            stringYear = stringYear.slice(2, 4);
        }
        stringYear = this.padZeros(stringYear, 2);

        let reel = SafeJSON.get('json.filmReel', key);
        reel = this.padZeros(reel, 3);
        let sequence = SafeJSON.get('json.filmFrame', key);
        sequence = this.padZeros(sequence, 4);
        return ' ' + stringYear + ' ' + reel + ' ' + sequence;
    }
    padZeros(num, size) {
        let s = num + '';
        while (s.length < size) {
            s = '0' + s;
        }
        return s;
    }
    // Transfer and Appeals /////////////////////////////////////////////////////////////
    getClockDateByCaseEventCode(code: string): string {
        // look in the eventList for the code and if found, return that clock date.
        let eventList: Object[] = this.json.caseEventList;

        if (eventList === undefined) {
            return '';
        }

        for (let i = 0; i < eventList.length; i++) {
            let eventCode = SafeJSON.get('caseEventList[' + i + '].caseEvent.code', this.json);
            if (eventCode === code) {
                return SafeJSON.get('caseEventList[' + i + '].clockDate', this.json);
            }
        }
        return '';
    }
    getInitiatedAppealFromCaseNumber(): string {
        // look in the eventList for INAP code and if found, return that filenumber
        let eventList: Object[] = this.json.caseEventList;

        if (eventList === undefined) {
            return '';
        }

        for (let i = 0; i < eventList.length; i++) {
            let eventCode = SafeJSON.get('caseEventList[' + i + '].caseEvent.code', this.json);
            if (eventCode === 'INAP') {
                return SafeJSON.get('caseEventList[' + i + '].fromCaseNumber.fileNumber', this.json);
            }
        }
        return '-';
    }
    getInitiatedAppealedToCase(): string {
        return this.getCaseNumber();
    }
    getInitiatedAppealedByParty(): string {
        return '*' + SafeJSON.getWithDefault('', this.json);
    }
    getInitiatedAppealedIssue(): string {
        return '*' + SafeJSON.getWithDefault('', this.json);
    }
    getInitiatedResultReturnedByCourt(): string {
        return '*' + SafeJSON.getWithDefault('', this.json);
    }
    getNoticeOfTransferAppealClockDate(appeal: any): string {
        return SafeJSON.get('clockDate', appeal.json);
    }
    getTransferedTo(): string {
        return SafeJSON.getWithDefault('transferedToCase', this.json);
    }
    getTransferedToCaseDate(): string {
        const xferDate = SafeJSON.getWithDefault('transferedToCase.transferedOnDate', this.json);
        return xferDate;
    }
    getTransferedFrom(): string {
        return SafeJSON.getWithDefault('transferedFromCase', this.json);
    }
    getTransferedFromCaseDate(): string {
        const xferDate = SafeJSON.getWithDefault('transferedFromCase.transferedOnDate', this.json);
        return xferDate;
    }
    getTransferedFromCaseNumber(): string {
        let caseNumber = SafeJSON.getWithDefault('transferedFromCase.caseNumber.fileNumber', this.json);
        return caseNumber;
    }
    getTransferedToCaseNumber(): string {
        let caseNumber = SafeJSON.getWithDefault('transferedToCase.caseNumber.fileNumber', this.json);
        return caseNumber;
    }
    getFromSmallClaimsCourtCaseNumber(): string {
        let fileNumber = SafeJSON.getWithDefault('transferedFromCase.caseNumber.fileNumber', this.json);
        if (fileNumber.search('CVM') === -1) {
            return '-';
        }
        return fileNumber;
    }
    getToDistrictCourtCaseNumber(): string {
        let fileNumber = SafeJSON.getWithDefault('transferedFromCase.caseNumber.fileNumber', this.json);
        if (fileNumber.search('CVD') === -1) {
            return '-';
        }
        return fileNumber;
    }
    caseEventCodeFound(field: string): string {
        let eventList: Object[] = this.json.caseEventList;

        if (eventList === undefined) {
            return '-';
        }

        // scan the event list and look for the requested code
        for (let i = 0; i < eventList.length; i++) {
            let code: string = SafeJSON.get('caseEventList[' + i + '].caseEvent.code', this.json);
            if (code === field) {
                return 'YES';
            }
        }
        return 'NO';
    }
    /*  getTransferEventList(): CaseEventHistory[] {
         let code1 = 'INTR';
         let code2 = 'DISP';
         let tlist: CaseEventHistory[] = Array.from(this.caseEventHistoryMap.values())
             .filter(transfer => transfer.getCode() === code1 || transfer.getCode() === code2);
         return tlist;
     } */
    getAppealToFormattedShortFileNumber(): string {
        return SafeJSON.get('appealTo.formattedShortFileNumber', this.json);
    }


    /**
    * get the pleadings/issues diplsay list used in search result screen
    * for the pleadings/issues grid table
    */
    getPleadingsIssuesDisplayList(): any[] {
        let pleadingDisplayList: any[] = [];
        let currentCase: JuvenileCase = this;

        if (currentCase.getPleadingList !== undefined) {
            for (let pleading of currentCase.getPleadingList()) {
                let pleadingClockDate: any = pleading.getClockDate();
                let pleadingType: any = pleading.getType();
                let pleadingIssueType: any = '';
                for (let issue of currentCase.getIssueListByPleadingKey(pleading.getPleadingKey())) {
                    pleadingIssueType = issue.getType();

                    let pleadingDisplayRow: any = {
                        pleadingClockDate: pleadingClockDate,
                        pleadingType: pleadingType,
                        pleadingIssueType: pleadingIssueType,
                    };

                    pleadingDisplayList.push(pleadingDisplayRow);
                }
            }
        }

        // sorting in clock date, pleading type and issue type
        pleadingDisplayList.sort(function (p1, p2) {
            if (p1.pleadingClockDate.localeCompare(p2.pleadingClockDate) === 0) {
                if (p1.pleadingType.localeCompare(p2.pleadingType) === 0) {
                    return p1.pleadingIssueType.localeCompare(p2.pleadingIssueType);
                } else {
                    return p1.pleadingType.localeCompare(p2.pleadingType);
                }
            } else {
                return p1.pleadingClockDate.localeCompare(p2.pleadingClockDate);
            }
        });

        return pleadingDisplayList;
    }
    getLastUpdatedDate(): string {
        let dateTS = this.searchRecordLastUpdateDate;
        let date = this.convertDate(dateTS);
        return date;
    }
    getLastUpdatedTime(): string {
        let dateTS = this.searchRecordLastUpdateDate;
        let time = this.convertTime(dateTS);
        return time;
    }
    getPayoffHoverDisclaimer(): string {
        return 'Payoff amounts were calculated on ' + this.getInterestedCalculatedDate() +
            ' based on the information retrieved from the system of record on ' +
            this.getLastUpdatedDate() + ' at  ' + this.getLastUpdatedTime() +
            '. For the most accurate payoff amount, please see the clerk.';
    }
    getInterestedCalculatedDate(): string {
        let dateTS = this.searchRecordLastUpdateDate;
        let date = this.convertDate(dateTS);
        return date;
    }
    convertDate(date: string): string {
        let datePipe = new DatePipe('en-US');
        return datePipe.transform(date, 'MM/dd/yyyy');
    }
    convertTime(time: string): string {
        let datePipe = new DatePipe('en-US');
        return datePipe.transform(time, 'jm');
    }

    /**
* listener for click on show button
* @param i the index of the row (i.e the index of the case)
*/
    showPleading(i: number) {
        this.pleadingShowFlags[i] = true;
    }

    /**
     * listener for click on hide button, which will set the pleadingHideNorifyFlags[i] (i.e. the ith row).
     * @param i the index of the row (i.e the index of the case)
     */
    hidePleading(i: number) {
        this.pleadingHideNotifyFlags[i] = true;
    }

    /**
     * onPleadingClosed event handler
     * @param i the index of the row (i.e the index of the case)
     */
    onPleadingClosed(i: number) {
        this.pleadingHideNotifyFlags[i] = false;
        this.pleadingShowFlags[i] = false;
    }

    isPleadingFlag(i: number): boolean {
        return this.pleadingShowFlags[i];
    }

    getJuvenileNameFromSearch() {
        return this.juvenileNameFromSearch;
    }

    setJuvenileNameFromSearch(juvenileNameFromSearch: string) {
        this.juvenileNameFromSearch = juvenileNameFromSearch;
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case.ts